#
# 文件相关的全局交互
#

$ ->
  $(document)
  # shortcut links for deleting doc
  .on "ajax:success", ".doc-item .doc-links .doc-delete", (e, result) ->
    if result.success
      $(@).closest('.doc-item').slideUp 'fast', ->
        $(@).remove()
        tower.refreshSelectedDocs()

  # switch docs view
  .on 'click', '.docs-view .switch-view .link-view', (e) ->
    $link = $(@)
    return  if $link.hasClass('active')

    $link.addClass('active')
      .siblings('.link-view')
      .removeClass 'active'

    cacheKey = simple.url().toString('relative') + 'docs-view'

    if $link.hasClass('link-grid-view')
      $link.closest('.docs-view')
        .addClass('grid-view')
        .removeClass 'list-view'
      simple.util.storage.set cacheKey, 'grid'
    else
      $link.closest('.docs-view')
        .addClass('list-view')
        .removeClass 'grid-view'
      simple.util.storage.set cacheKey, 'list'

  # sort file list
  .on 'click', '.docs-view.list-view .doc-header[data-sortable]', (e) ->
    $header = $(@)
    desc = if $header.data('sortable') == 'desc' then 'asc' else 'desc'
    col = undefined
    if $header.hasClass('name-header')
      col = 'name'
    else if $header.hasClass('saver-header')
      col = 'saver'
    else if $header.hasClass('update-time-header')
      col = 'update-time'
    tower.sortDocList col, desc
    cacheKey = simple.url().toString('relative') + 'doc-list-sort'
    simple.util.storage.set cacheKey, col + ';' + desc


$.extend window.tower,
  initDocViews: () ->
    $view = $('.docs-view')
    viewKey = simple.url().toString('relative') + 'docs-view'
    view = simple.util.storage.get(viewKey)

    if !view and $('#page-project').length > 0
      view = 'grid'
      simple.util.storage.set viewKey, view

    if view
      $link = $view.find('.switch-view .link-' + view + '-view')
      $link.addClass('active')
        .siblings('.link-view')
        .removeClass 'active'
      if view == 'grid'
        $link.closest('.docs-view')
          .addClass('grid-view')
          .removeClass 'list-view'
      else
        $link.closest('.docs-view')
          .addClass('list-view')
          .removeClass 'grid-view'

    sortKey = simple.url().toString('relative') + 'doc-list-sort'
    sort = simple.util.storage.get(sortKey)
    if sort
      sort = sort.split(';')
      tower.sortDocList sort[0], sort[1]

    $selectedInfo = $view.find('.doc-selected-info')
    $(window).on "scroll.docs-view", (e) ->
      if !$selectedInfo.is(':visible')
        return

      topEdge = $view.offset().top - 43
      bottomEdge = topEdge + $view.outerHeight() - 80
      scrollTop = $(document).scrollTop()

      if (scrollTop <= topEdge || scrollTop >= bottomEdge)
        $selectedInfo
          .css('left', '')
          .removeClass('floating')
      else
        $selectedInfo
          .css('left', $selectedInfo.offset().left)
          .addClass('floating')

    baseSelected = []
    $view.data('base-selected', baseSelected)
    $(document).on 'click.docs-view', (e) ->
      baseSelected = $view.data('base-selected')
      return unless baseSelected

      $target = $(e.target)
      if $target.closest('.doc-list, .doc-selected-info, .simple-dialog-modal, .simple-dialog').length < 1
        if $('.doc-or-dir').length > 1
          $view.find('.doc-or-dir').removeClass('selected')

        tower.refreshSelectedDocs()
        baseSelected.length = 0

  sortDocList: (col, order) ->
    $view = $('.docs-view')
    $list = $view.find('.doc-list')
    $header = $view.find('.' + col + '-header')
    $rows = $list.find('.doc-or-dir')
    if $view.length < 1
      return
    if col == 'name'
      $rows.sort (row1, row2) ->
        name1 = $.trim $(row1).find('.link').text()
        name2 = $.trim $(row2).find('.link').text()
        name2.localeCompare name1, undefined, numeric: true

    else if col == 'saver'
      $rows.sort (row1, row2) ->
        name1 = $.trim $(row1).find('.doc-dir-creator, .doc-saver').text()
        name2 = $.trim $(row2).find('.doc-dir-creator, .doc-saver').text()
        name2.localeCompare name1
    else if col == 'update-time'
      $rows.sort (row1, row2) ->
        date1 = $(row1).find('.doc-update-time span, .doc-dir-update-time span').data('readable-time')
        date2 = $(row2).find('.doc-update-time span, .doc-dir-update-time span').data('readable-time')
        format = 'YYYY-MM-DD HH:mm:ss Z'
        date1 = moment.tz(date1, format, tower.me.tz)
        date2 = moment.tz(date2, format, tower.me.tz)
        date2.diff date1
    $header.attr('data-sortable', order).removeData 'sortable'
    $rows = $($rows.get().reverse()) if order == 'asc'
    $header.siblings('.doc-header[data-sortable]')
      .attr('data-sortable', '')
      .removeData 'sortable'
    $list.append $rows
